import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Footer.module.css';
import robotImage from './images/BOTBlack2.webp';
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram} from "@react-icons/all-files/fa/FaInstagram";
import logo from './images/logo_con_letras_negro.png';

const Footer = () => {
  const navigate = useNavigate();

  const handleFAQClick = () => {
    // Navega a la home page y luego añade el hash para la sección FAQ
    navigate('/#FAQ', { replace: true });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <h2 className={styles.title}><span className={styles.highlight2}>Conecta con</span> <span className={styles.highlight}>Nosotros</span></h2>
        <img src={logo} alt='RelatividadIA' className={styles.logo} onClick={() => navigate('/')}/>
        <div className={styles.columns}>
          <div className={styles.column}>
            <h3>Empresa</h3>
            <ul>
              <li><a onClick={() => navigate('/acerca-de')}>Acerca De</a></li>
              <li><a onClick={() => navigate('/contacto')}>Contactos</a></li>
              <li><a onClick={() => window.location.href = 'https://www.instagram.com/relatividadia/'}>Instagram</a></li>
              <li><a onClick={() => window.location.href = 'https://www.linkedin.com/company/relatividad-ia/mycompany/'}>LinkedIn</a></li>
            </ul>
          </div>
          <div className={styles.column}>
            <h3>Productos</h3>
            <ul>
              <li><a onClick={() => navigate('/clones-info')}>Bot IA</a></li>
              <li><a onClick={() => navigate('/calificador-info')}>Calificador IA</a></li>
              <li><a onClick={() => navigate('/smartbook-AI-info')}>Smartbook IA</a></li>
              
            </ul>
          </div>
          <div className={styles.column}>
            <h3>Preguntas Frecuentes</h3>
            <ul>
              <li><a onClick={handleFAQClick}>Resuelve tus dudas sobre Relatividad IA</a></li>
            </ul>
          </div>
        </div>
        <img src={robotImage} alt="AI Robot" className={styles.robotImage} />
      </div>
      <div className={styles.bottomBar}>
      <p>
        Copyright © 2025 Relatividad IA. Todos los derechos reservados.
        {' | '}
        <span
          style={{ cursor: 'pointer'}}
          onClick={() => navigate('/politica-privacidad')}
        >
          Política de privacidad
        </span>
        {' | '}
        <span
          style={{ cursor: 'pointer'}}
          onClick={() => navigate('/terminos-condiciones')}
        >
          Términos y Condiciones
        </span>
      </p>
        <div className={styles.socialIcons}>
          <FaInstagram className={styles.icon1} onClick={() => window.location.href = 'https://www.instagram.com/relatividadia/'}/>
          <FaLinkedin className={styles.icon2} onClick={() => window.location.href = 'https://www.linkedin.com/company/relatividad-ia/mycompany/'}/>
        </div>
      </div>
    </footer>
  );
};

export default Footer;